import React from 'react'
import { DateTime } from "luxon";


const getWorkingDaysBetween = function (startDate, endDate, dayFlags) {
    if (startDate < endDate) {
        return -1
    }
    let totalWorkingDays = 0;

    while (startDate > endDate) {
        endDate = endDate.plus({ days: 1 });
        const weekDay = endDate.weekday;
        if (dayFlags[weekDay - 1]) {
            totalWorkingDays++;
        }
    }

    return totalWorkingDays;
}

class DaysDifference extends React.Component {

    render() {



        const workSpaceTimeZone = this.props.timeZone;

        const todayStartDateTime = DateTime.local().setZone(workSpaceTimeZone).startOf('day');
        const todayEndDateTime = DateTime.local().setZone(workSpaceTimeZone).endOf('day');

        const startDate = this.props.startDate;
        const endDate = this.props.endDate;

        const startDateTime = DateTime.fromISO(startDate).setZone(workSpaceTimeZone).startOf('day');
        const endDateTime = DateTime.fromISO(endDate).setZone(workSpaceTimeZone).endOf('day');


        //Difference in number of days
        const startDateDiff = startDateTime.diff(todayStartDateTime, 'days');
        const startDayDifference = startDateDiff.toObject().days;

        const endDateDiff = endDateTime.diff(todayEndDateTime, 'days');
        const endDayDifference = endDateDiff.toObject().days;
        const daysBetweenStartToday = getWorkingDaysBetween(todayStartDateTime, startDateTime, this.props.workingDays);
        const daysBetweenTodayEnd = getWorkingDaysBetween(todayEndDateTime, endDateTime, this.props.workingDays);




        let dateComponent = null;

        if (startDateTime > todayStartDateTime) {
            dateComponent = <span> Not Started  </span>
        } else {
            if (this.props.isInitiativeStarted) {
                //true when the activity/initiative should be active
                if (startDateTime <= todayStartDateTime && endDateTime >= todayEndDateTime) {
                    dateComponent = <span>Day {daysBetweenStartToday + 1} of {this.props.totaldays}</span>
                }

                //true when the activity/initiative end date is expired
                if (endDateTime < todayEndDateTime) {
                    dateComponent = <span>Delayed to end by {daysBetweenTodayEnd} {daysBetweenTodayEnd === 1 ? "day" : "days"}</span>
                }
            } else {//initiative is not started
                if (startDateTime <= todayStartDateTime) {
                    if (daysBetweenStartToday === 0) {
                        dateComponent = <span>Day 0 of {this.props.totaldays}</span>
                    } else {
                        dateComponent = <span>Delayed to start by {daysBetweenStartToday} {daysBetweenStartToday === 1 ? "day" : "days"}</span>
                    }

                }
            }

        }

        return dateComponent;
    }
}

export default DaysDifference;
